module.exports = "pegasus/assets/header-fall-pets-1.jpg";